import { createUseStyles } from "react-jss";

export const textStyles = {
    title: {
        width: "100%",
        fontSize: "1.2em",
        margin: "0 0 1em 0",
           fontFamily: "sans-serif",
        fontWeight: "600",
        lineHeight:"1.1",
        textTransform:"uppercase"
    },
    titleMediumMargin: {
        width: "100%",
        fontSize: "1.5em",
        margin: "0 0 0.5em 0"
    },
    titleNoMargin: {
        width: "100%",
        fontSize: "1.5em"
    },
    bigTitle: {
        width: "100%",
        fontSize: "2em",
    },
    smallTitle: {
        width: "100%",
        fontSize: "0.75em"
    },
    subtitle: {
        width: "100%",
        fontSize: "1em",
        margin: "0 0 0.5em 0",
           fontFamily: "sans-serif"
    },
    description: {
        width: "100%",
        fontSize: "0.8em",
           fontFamily: "sans-serif"
    },
    annotation: {
        width: "100%",
        fontSize: "0.6em",
           fontFamily: "sans-serif"
    },
    mediumText: {
        width: "100%",
        fontSize: "1em"
    },
    link: {
        cursor: "pointer",
        textAlign: "center",
        color: "#2F4A4E",
        textDecoration: "underline",
        margin: "0.5em 0 0 0",
        fontSize: "0.8em"
    },
    alignContent: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    separateContent: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    error: { color: "#be123c" },
    left: { textAlign: "left" },
    right: { textAlign: "right" },
    center: { textAlign: "center" },
    autoWidth: { width: "unset" }
};
export const textClasses = createUseStyles(textStyles);